import React, { useEffect,useState } from "react";
import Sidebar from "../components/Sidebar";
import { post } from "../network/api";
import { useTranslation } from "react-i18next";

const Wallet = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const [transactions, setTransactions] = useState([
    
  ]);
  
  useEffect(() => {
    getWalletBalance();
    getTransactions();
  }, []);
  async function getWalletBalance() {
    try {
      // setLoading(true)
      const data = await post("customer/wallet-balance");
      setWalletBalance(data);
      // setLoading(false)
    } catch (error) {
      // setLoading(false);
    }
  }
  async function getTransactions() {
    try {
      setLoading(true)
      const data = await post("customer/wallet-transactions");
      setTransactions(data);
      setLoading(false)
    } catch (error) {
      setLoading(false);
    }
  }

  return (
    <React.Fragment>
      <section>
        <div className="wrapper">
          <div className="account_grid">
            <Sidebar />
            <div className="page-content wallet-page">
              {/* Wallet Balance Section */}
              <div className="wallet-balance-card">
                <h2>{t('wallet_balance')}</h2>
                <p className="wallet-amount">₹{walletBalance.toFixed(2)}</p>
              </div>

              {/* Transaction List Table */}
              <div className="transaction-list">
                <h3>{t('transaction_history')}</h3>
                <div className="overflow_div">
                  <table className="transaction-table order-table">
                    <thead>
                      <tr>
                        <th>{t('date')}</th>
                        <th>{t('description')}</th>
                        <th>{t('amount')}</th>
                        <th className="text-center">{t('status')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.map((transaction) => (
                        <tr key={transaction.id}>
                          <td>{transaction.date.substring(0,16).replace("T"," ")}</td>
                          <td>{transaction.description}</td>
                          <td
                            className={`amount ${
                              transaction.type =='credit' ? "positive" : "negative"
                            }`}
                          >
                            ₹{transaction.amount.toFixed(2)}
                          </td>
                          <td className="text-center">
                            <span
                            // className={`amount ${
                            //   transaction.type =='credit' ? "positive" : "negative"
                            // }`}
                              // className={`status text-center ${transaction.type =='credit' ? "positive" : "negative"}`}
                            >
                              {transaction.type.toUpperCase()}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Wallet;
